"use strict";

var _createClass = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/classCallCheck.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var communication_1 = __importDefault(require("./communication"));

var txs_1 = require("./txs");

var eth_1 = require("./eth");

var safe_1 = require("./safe");

var SafeAppsSDK = /*#__PURE__*/_createClass(function SafeAppsSDK() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, SafeAppsSDK);

  var _opts$whitelistedDoma = opts.whitelistedDomains,
      whitelistedDomains = _opts$whitelistedDoma === void 0 ? null : _opts$whitelistedDoma,
      _opts$debug = opts.debug,
      debug = _opts$debug === void 0 ? false : _opts$debug;
  this.communicator = new communication_1.default(whitelistedDomains, debug);
  this.eth = new eth_1.Eth(this.communicator);
  this.txs = new txs_1.TXs(this.communicator);
  this.safe = new safe_1.Safe(this.communicator);
});

exports.default = SafeAppsSDK;